"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var Tooltip_1 = require("./Tooltip");
var TooltipContent_1 = require("./TooltipContent");
__export(require("./Tooltip"));
__export(require("./TooltipContent"));
var TooltipModule = (function () {
    function TooltipModule() {
    }
    return TooltipModule;
}());
TooltipModule = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule
        ],
        declarations: [
            Tooltip_1.Tooltip,
            TooltipContent_1.TooltipContent,
        ],
        exports: [
            Tooltip_1.Tooltip,
            TooltipContent_1.TooltipContent,
        ],
        entryComponents: [
            TooltipContent_1.TooltipContent
        ]
    })
], TooltipModule);
exports.TooltipModule = TooltipModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-tooltip/index.js
// module id = 319
// module chunks = 3